import styled from "styled-components"
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { LAYERS } from "common/sizes";

export interface IRootProps {
  displayValue?: string;
  hoverValue?: string;
  backgroundColorValue?: string;
  colorValue?: string;
  borderColorValue?: string;
}

export const Root = styled.div`
  display: ${(props: IRootProps) => (props.displayValue ?? 'auto')};
  position: relative;
`

export const Icon = styled.div`
  position: fixed;
  z-index: ${LAYERS.LAYER_6};
  top: 0px;
  right: 0px;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${(props: IRootProps) => (props.backgroundColorValue ?? 'auto')};
  &:hover {
    background-color: #4da0ff;
  }
`

export const Container = styled.div`
  display: ${(props: IRootProps) => (props.displayValue ?? 'auto')};
  z-index: ${LAYERS.LAYER_2};
  position: fixed;
  top: 60px;
  right: 0px;
  width: 292px;
  box-shadow: -4px 4px 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  font-family: ${DEFAULT_FONT_FAMILY};
`

export const Title = styled.div`
  margin: 18px;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #545473;
`

export const CloseIconContainer = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  cursor: pointer;
`

export const SyncRow = styled.div`
  display: flex;
  padding: 14px 14px 0px 14px;
  align-items: center;
`

export const SyncText = styled.div`
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #545473;
`

export const OptionsContainer = styled.div`
  padding: 11px;
`

export const Option = styled.div`
  position: relative;
  padding: 12px;
  border-radius: 5px;
  &:hover {
    background-color: ${(props: IRootProps) => (props.hoverValue ?? '#f2f5fa')};
  }
`

export const OptionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #545473;
`

export const ButtonContainer = styled.div`
  position: absolute;
  top: 7px;
  right: 3px;
  display: flex;
`

export const OptionButton = styled.div`
  display: ${(props: IRootProps) => (props.displayValue ?? 'auto')};
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.7px;
  text-align: left;
  color: ${(props: IRootProps) => (props.colorValue ?? '#4da0ff')};
  padding: 6px 10px;
  &:hover {
    padding: 5px 9px;
    border-radius: 5px;
    border: solid 1px ${(props: IRootProps) => (props.borderColorValue ?? '#4da0ff')};
  }
`

export const InfoButton = styled.div`
  position: absolute;
  top: 15px;
  right: 25px;
  width: 378px;
  height: 37px;
  display: ${(props: IRootProps) => ('none')};
  justify-content: center;
  align-items: center;
  box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #272727;
  border-radius: 5px;
  background-color: #112240;
  font-family: Rubik;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  ${OptionButton}:hover & {
    display: ${(props: IRootProps) => (props.displayValue ?? 'flex')};
  }
`

export const OptionDescription = styled.div`
  display: ${(props: IRootProps) => (props.displayValue ?? 'auto')};
  margin-top: 7px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #545473;
`

export const ListContainer = styled.div`
  padding: 10px 0px;
`

export const ListItemContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0px;
`

export const ListItemRadioButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

export const ListItemDescription = styled.div`
  margin-left: 9px;
  font-family: Rubik;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #545473;
`
